import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { MobileDetectorService } from '@services/MobileDetectorService/mobile-detector.service';

@Component({
  selector: 'app-adaptive-modal',
  templateUrl: './adaptive-modal.component.html',
  styleUrls: ['./adaptive-modal.component.scss']
})
export class AdaptiveModalComponent implements OnInit {

  @Input() title: string;
  @Input() fullscreen: boolean = false;
  @Input() hasBackdrop: boolean = true;
  @Input() hideHeader: boolean = false;
  @Input() showModal: EventEmitter<boolean>;

  constructor(
    public mobileDetector: MobileDetectorService,
  ) { }

  ngOnInit(): void {
  }

}
